import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

export const SUPPORTED_LANGS = ['en', 'de', 'tr'] as const;
export type Lang = typeof SUPPORTED_LANGS[number];

const STORAGE_KEY = 'mm_lang';

@Injectable({ providedIn: 'root' })
export class LangService {
  readonly current$ = new BehaviorSubject<Lang>('en');

  constructor(private translate: TranslateService) {}

  init(): void {
    this.translate.addLangs([...SUPPORTED_LANGS]);
    this.translate.setFallbackLang('en');
    const saved = localStorage.getItem(STORAGE_KEY) as Lang | null;
    const browser = this.translate.getBrowserLang() as Lang;
    const use: Lang = saved ?? (SUPPORTED_LANGS.includes(browser) ? browser : 'en');
    this.translate.use(use);
    this.current$.next(use);
  }

  use(lang: Lang): void {
    this.translate.use(lang);
    localStorage.setItem(STORAGE_KEY, lang);
    this.current$.next(lang);
  }

  get current(): Lang {
    return this.current$.value;
  }
}
